import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import initializeCapacitor from "./capacitor";

// Initialize Capacitor for native mobile support
initializeCapacitor();

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // SW registered
      })
      .catch(error => {
        // SW registration failed
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
